import { useCallback } from "react";

import { FilterQueryOptions } from "../../TreePicklistItemProvider";

import { CommonTreeNodeProps } from "./ITreeNodeProps";

export const useTryToRequestNodes = (props: CommonTreeNodeProps) => {
    const tryToRequestNodes = useCallback(async (filterQueryOptions: FilterQueryOptions) => {
        const response = await props.treeQuery(filterQueryOptions);

        return response.items;
    }, []);

    return tryToRequestNodes;
};
